import { t } from '../i18n';
import type { MessageKey } from '../i18n/en';
/**
 * The moving "wall of entertainment" behind the login card: rows of colourful
 * tiles drifting sideways under slowly floating lights. Only transforms and
 * opacity animate, so it stays smooth on phones and TV browsers; it holds
 * still for viewers who ask for reduced motion.
 */
const TILES: { label: MessageKey; icon: keyof typeof ICONS; hue: string }[] = [
  { label: 'tile.sports', icon: 'trophy', hue: 'red' },
  { label: 'tile.movies', icon: 'film', hue: 'violet' },
  { label: 'tile.series', icon: 'tv', hue: 'blue' },
  { label: 'tile.kids', icon: 'star', hue: 'amber' },
  { label: 'tile.music', icon: 'note', hue: 'pink' },
  { label: 'tile.news', icon: 'live', hue: 'teal' },
  { label: 'tile.uhd', icon: 'play', hue: 'orange' },
  { label: 'tile.docs', icon: 'globe', hue: 'green' },
  { label: 'tile.football', icon: 'trophy', hue: 'blue' },
  { label: 'tile.cinema', icon: 'film', hue: 'red' },
  { label: 'tile.cartoons', icon: 'star', hue: 'violet' },
  { label: 'tile.concerts', icon: 'note', hue: 'amber' },
];

const ICONS = {
  play: <path d="M9 6.5v11l9-5.5z" />,
  film: <path d="M5 5h14v14H5zM8 5v14M16 5v14M5 9h3M5 15h3M16 9h3M16 15h3" fill="none" strokeWidth="1.8" />,
  tv: <path d="M4 7h16v10H4zM9 20h6M12 17v3M9 3l3 3 3-3" fill="none" strokeWidth="1.8" />,
  trophy: <path d="M7 4h10v4a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M12 13v3M8 20h8M9.5 16h5v4h-5z" fill="none" strokeWidth="1.8" />,
  star: <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z" />,
  note: <path d="M10 17.5a2.5 2.5 0 1 1-2.5-2.5H10V5l9-2v12.5a2.5 2.5 0 1 1-2.5-2.5H19V6.2l-9 2z" />,
  live: <path d="M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7.8 7.8a6 6 0 0 0 0 8.4M16.2 7.8a6 6 0 0 1 0 8.4M5 5a10 10 0 0 0 0 14M19 5a10 10 0 0 1 0 14" fill="none" strokeWidth="1.8" />,
  globe: <path d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM4 12h16M12 4c2.5 2.5 2.5 13.5 0 16M12 4c-2.5 2.5-2.5 13.5 0 16" fill="none" strokeWidth="1.6" />,
};

/** Each row starts at a different tile so neighbouring rows do not line up. */
const ROWS = [0, 4, 8, 2, 6, 10, 3];

export function GateBackdrop() {
  return (
    <div className="gate-backdrop" aria-hidden="true">
      <div className="gate-backdrop__glow gate-backdrop__glow--1" />
      <div className="gate-backdrop__glow gate-backdrop__glow--2" />
      <div className="gate-backdrop__glow gate-backdrop__glow--3" />
      <div className="gate-backdrop__wall">
        {ROWS.map((start, row) => {
          const tiles = [...TILES.slice(start), ...TILES.slice(0, start)];
          return (
            <div key={row} className={`gate-backdrop__row gate-backdrop__row--${row + 1}`}>
              {/* Two copies: the row slides by exactly one copy, then repeats seamlessly. */}
              {[0, 1].map((copy) => (
                <div key={copy} className="gate-backdrop__strip">
                  {tiles.map((tile) => (
                    <div key={tile.label} className={`gate-tile gate-tile--${tile.hue}`}>
                      <svg className="gate-tile__icon" viewBox="0 0 24 24">
                        {ICONS[tile.icon]}
                      </svg>
                      <span className="gate-tile__label">{t(tile.label)}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div className="gate-backdrop__shade" />
    </div>
  );
}
